import type { Episode } from '@/domain/episode'

// Placeholder CyberTales episodes (Document 11 §1/§6): realistic metadata
// and structure, sample video, no final animation asset required. When real
// CyberTales/Cyber Wahala episodes are ready, replace videoUrl/thumbnail
// values here — no other code changes.
export const seedEpisodes: Episode[] = [
  {
    id: 'ep-phishing-trap',
    title: 'The Phishing Trap',
    synopsis:
      "When Amaka receives an urgent email claiming her bank account is 'locked', she has minutes to decide: click the link, or spot the trap? Follow her story through the anatomy of a phishing attack.",
    topicTags: ['phishing', 'email-safety'],
    difficulty: 'beginner',
    durationSeconds: 330,
    languages: ['en'],
    learningObjectives: [
      'Recognize the warning signs of a phishing email',
      'Understand why urgency and fear are used as manipulation tactics',
      'Know the safe steps to take before clicking any link',
    ],
    videoUrl: 'https://storage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    thumbnailGradient: ['#0A1020', '#22D3EE'],
    linkedQuizId: 'quiz-phishing-101',
    cmsStatus: 'published',
    cmsVersion: 1,
  },
  {
    id: 'ep-simswap-shadows',
    title: 'SIM Swap Shadows',
    synopsis:
      "Kwame's phone suddenly loses signal — and within the hour, his mobile money account is drained. A tale of SIM-swap fraud, and the everyday habits that stop it before it starts.",
    topicTags: ['mobile-money-fraud', 'sim-swap', 'social-engineering'],
    difficulty: 'intermediate',
    durationSeconds: 375,
    languages: ['en'],
    learningObjectives: [
      'Understand how SIM-swap fraud works, step by step',
      'Identify the early warning signs of a SIM-swap attempt',
      'Apply account-recovery best practices for mobile money and banking apps',
    ],
    videoUrl: 'https://storage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
    thumbnailGradient: ['#0F1830', '#F2A93B'],
    linkedQuizId: 'quiz-simswap-101',
    cmsStatus: 'published',
    cmsVersion: 1,
  },
  {
    id: 'ep-password-fortress',
    title: 'Password Fortress',
    synopsis:
      'Tunde reuses the same password everywhere — until one leaked database turns his whole digital life into an open door. Build the habits that make a password fortress instead of a house of cards.',
    topicTags: ['passwords', 'account-security'],
    difficulty: 'beginner',
    durationSeconds: 285,
    languages: ['en'],
    learningObjectives: [
      'Explain why password reuse is dangerous',
      'Describe what makes a password strong',
      'Understand the role of multi-factor authentication',
    ],
    videoUrl: 'https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
    thumbnailGradient: ['#16213D', '#818CF8'],
    linkedQuizId: 'quiz-password-101',
    cmsStatus: 'published',
    cmsVersion: 1,
  },
]
